import { render, staticRenderFns } from "./DetailPelanggaran.vue?vue&type=template&id=4bd0ccaa&scoped=true"
import script from "./DetailPelanggaran.vue?vue&type=script&lang=js"
export * from "./DetailPelanggaran.vue?vue&type=script&lang=js"
import style0 from "./DetailPelanggaran.vue?vue&type=style&index=0&id=4bd0ccaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd0ccaa",
  null
  
)

export default component.exports